import { Suspense } from 'react';
import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
  Outlet,
} from 'react-router-dom';
import { ROUTES, LazyPages } from './routes.config';
import Layout from '@/shared/components/Layout';
import ProtectedRoute from '@/shared/components/ProtectedRoute';

// Loading component
const PageLoader = () => (
  <div className="flex items-center justify-center min-h-screen">
    <div className="flex flex-col items-center space-y-4">
      <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600" />
      <p className="text-gray-600">Cargando...</p>
    </div>
  </div>
);

// Wrapper for suspense
const SuspenseRoute = ({ children }: { children: React.ReactNode }) => (
  <Suspense fallback={<PageLoader />}>{children}</Suspense>
);

export function AppRouter() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Public Routes */}
        <Route
          path={ROUTES.LOGIN}
          element={
            <SuspenseRoute>
              <LazyPages.Login />
            </SuspenseRoute>
          }
        />

        <Route
          path={ROUTES.PASSWORD_RECOVERY}
          element={
            <SuspenseRoute>
              <LazyPages.PasswordRecovery />
            </SuspenseRoute>
          }
        />

        <Route
          path={ROUTES.FORGOT_PASSWORD}
          element={
            <SuspenseRoute>
              <LazyPages.ForgotPassword />
            </SuspenseRoute>
          }
        />

        <Route
          path={ROUTES.RESET_PASSWORD}
          element={
            <SuspenseRoute>
              <LazyPages.ResetPassword />
            </SuspenseRoute>
          }
        />

        {/* Protected Routes */}
        <Route
          element={
            <ProtectedRoute>
              <Layout>
                <Outlet />
              </Layout>
            </ProtectedRoute>
          }
        >
          <Route index element={<Navigate to={ROUTES.DASHBOARD} replace />} />

          <Route
            path={ROUTES.DASHBOARD}
            element={
              <SuspenseRoute>
                <LazyPages.Dashboard />
              </SuspenseRoute>
            }
          />

          <Route
            path={ROUTES.MANIFIESTOS}
            element={
              <SuspenseRoute>
                <LazyPages.Manifiestos />
              </SuspenseRoute>
            }
          />

          <Route
            path={ROUTES.GUIAS}
            element={
              <SuspenseRoute>
                <LazyPages.Documentos />
              </SuspenseRoute>
            }
          />
        </Route>

        {/* Catch all - 404 */}
        <Route path="*" element={<Navigate to={ROUTES.DASHBOARD} replace />} />
      </Routes>
    </BrowserRouter>
  );
}

